// i18n area 'apps' — locale is-IS (task #171, ratifica Luca 2026-08-04: l'islandese
// entra come 28ª lingua): tradotto DALL'ITALIANO (lingua SORGENTE, regola
// 2026-08-03). Glossario di sezione: mynd (immagine OCI), gámur (container),
// sniðmát (template), raungera (materializzare), úthýsa (evizionare), safnari
// (collettore), hverfull (effimero), varanlegur (persistente), veitandi
// (provider), rauf (slot); restano invariati registry, repository, branch,
// digest, reflog, lockfile, blob, layer, head, pull, refresh, drift, detached,
// pinned/tracking, root, rootfs, volume, worker, scheduler, air-gapped.
// Sidecar anti-stantie: ../meta/apps.is-IS.meta.json.
import type { enUS } from './apps'

export const isIS: typeof enUS = {

  // Apps wave 1 (Annex R): container podman gestiti — supervisionati dal
  // worker su un nodo dichiarato; immagine = lockfile branch@digest (Annex Q)
  // con policy pinned/tracking; attacco L3 untagged con IP statico.
  apps: {
    title: 'Öpp',
    create: 'Búa til app',
    createTitle: 'Búa til app',
    editTitle: 'Breyta appi',
    name: 'Nafn',
    nameHint: 'DNS-1123, einkvæmt innan scope — óbreytanlegt eftir stofnun.',
    node: 'Hnútur',
    nodeHint: 'Meðlimshnúturinn sem keyrir það — skýr staðsetning (scheduler kemur síðar).',
    image: 'Mynd',
    editImageHint: 'Ný tilvísun er leyst upp aftur gegnum skrána — þetta er pin/rollback-handtakið.',
    imagePolicy: 'Stefna',
    policyPinned: 'pinned',
    policyTracking: 'tracking',
    policyPinnedHint: 'Digest-ið hreyfist aðeins á skipun.',
    policyTrackingHint: 'Sjálfvirkt rolling þegar refresh hreyfir branch-ið.',
    archMovePolicy: 'Cross-arch færsla',
    archMoveRefuse: 'refuse',
    archMoveReresolve: 'reresolve',
    archMovePolicyHint: 'Hvað gerist ef appið er fært á hnút með annarri högun: refuse hafnar færslunni, reresolve leysir lockfile-inn upp á ný úr branch-inum á nýju arch — innihaldið breytist, og svarið nefnir digest-breytinguna.',
    network: 'Net',
    networkHint: 'Untagged L3-tenging: röklegt fabric-net (mælt með því — gátt/DNS frá einu uppsprettunni), overlay, eða ber hýsilbrú (ekki mælt með því).',
    overlayPrefix: 'overlay:',
    fabricPrefix: 'fabric:',
    bridgePrefix: 'hýsilbrú:',
    ipAssignment: 'IP-úthlutun',
    ipStatic: 'Fast',
    ipAuto: 'Sjálfvirkt (IPAM)',
    ipAssignmentHint_static: 'Þú gefur vistfangið, núna.',
    ipAssignmentHint_auto: 'IPAM velur laust vistfang úr fráteknum TVirt-bilum netsins.',
    bridgeDiscouraged: 'Ber hýsilbrú — EKKI mælt með því: TVirt veit ekkert um vistföng hennar, svo gátt og DNS þarf að gefa handvirkt. Ráðlagða leiðin er röklegt fabric-net.',
    ip: 'IP',
    ipHint: 'Fast IPv4 innan undirnets tengingarinnar.',
    ipCidrHint: 'Á CIDR-formi á berri brú (t.d. 192.168.1.10/24) — það er hvergi hægt að leiða forskeytið af.',
    gateway: 'Gátt',
    gatewayManualHint: 'Handvirkt — ber brú leiðir ekkert af sér.',
    dnsServers: 'DNS-þjónar',
    dnsManualHint: 'Handvirkir, aðskildir með kommu — að minnsta kosti einn.',
    rootKind: 'Root',
    rootEphemeral: 'hverful',
    rootPersistent: 'varanleg',
    rootEphemeralHint: 'Endurgerð úr myndinni við hverja endursköpun; býr á hverfulu klasageymslunni.',
    rootEphemeralHintNamed: 'Endurgerð úr myndinni við hverja endursköpun; býr á hverfulu klasageymslunni ({name}).',
    rootPersistentHint: 'Lifir af endurræsingar; býr á geymslunni sem þú velur.',
    rootStorage: 'Root-geymsla',
    editRootStorageHint: 'Root er endurgerð á nýja pool-inu — fyrirliggjandi gögn flytjast EKKI af sjálfu sér.',
    volumes: 'Volume',
    volumeAdd: 'Bæta við volume',
    volumeName: 'Nafn',
    volumeMountPath: 'Tengipunktur',
    volumeKind: 'Tegund',
    volumeStorage: 'Geymsla',
    devices: 'Tæki',
    deviceClassHint: 'Beðið er um FLOKK (gpu-device- eða usb-device-merki), aldrei ákveðið tæki: uppgefni hnúturinn verður að eiga eitt merkt fyrir Apps. Mörg Apps geta notað sama tækið — gámur deilir því, hann tekur það ekki af hýsilnum.',
    deviceSlot: 'Rauf',
    deviceTag: 'Merki',
    deviceValue: 'Flokkur',
    deviceUnresolved: 'ekkert leysist eins og er',
    noDeviceTags: 'Ekkert merki af gerðinni gpu-device eða usb-device enn: búðu til eitt og úthlutaðu því á tækin sem eru merkt fyrir Apps.',
    env: 'Umhverfi',
    envHint: 'Eitt LYKILL=gildi í hverri línu.',
    secretEnvTitle: 'Leynilegar breytur',
    secretEnvNotice: 'Leynilegt gildi kemur aldrei aftur úr API-nu: enginn les það aftur, ekki einu sinni sá sem skrifaði það. Í checkpoint-inu ferðast það innsiglað með masterpass, þannig að endurheimt án masterpass biður um að það sé skrifað aftur.',
    secretEnvPromote: 'Gerðu eina af breytunum hér að ofan leynilega:',
    secretEnvAdd: 'Bæta við leynilegri breytu',
    secretEnvName: 'Nafn',
    secretEnvValue: 'Gildi',
    secretEnvKept: 'varðveitt — skildu eftir autt til að breyta því ekki',
    secretEnvWithdrawWarning: 'Til að hætta að meðhöndla sem leynilega breytu sem er það þegar skaltu skrifa henni nýtt gildi: að taka merkinguna eina af væri leið til að LESA það sem fer aldrei út úr store-inu. Að fjarlægja breytuna eyðir henni hins vegar.',
    secretEnvChip: 'leynilegt',
    startNow: 'Ræsa strax (annars fæðist appið stöðvað)',
    deletePersistentIntro: 'Þetta app á varanleg gögn — veldu hvað gera skal við þau:',
    deleteKeepData: 'Halda gögnunum (möppurnar sitja áfram á sínum geymslum, munaðarlausar)',
    deletePurgeData: 'Eyða líka gögnunum',
    phase: 'Fasi',
    phase_running: 'Í keyrslu',
    phase_stopped: 'Stöðvað',
    phase_error: 'Villa',
    phase_unknown: 'Óþekkt',
    desiredState: 'Óskað',
    wantedRunning: 'í keyrslu',
    wantedStopped: 'stöðvað',
    start: 'Ræsa',
    stop: 'Stöðva',
    restart: 'Endurræsa',
    refreshImage: 'Uppfæra mynd (tekur upp nýja @current)',
    logs: 'Annáll',
    logsTitle: 'Annáll',
    logsEmpty: 'Ekkert úttak fangað.',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'App-ið er ekki í gangi — shell þarf lifandi gám. Logga þess má lesa í hvaða stöðu sem er.',
    shellConnect: 'Tengjast',
    shellDisconnect: 'Aftengja',
    shellExited: 'Setunni lauk með útgangskóða {code}.',
    shellEndedWithoutStatus: 'Setunni lauk án útgangsstöðu: {reason}',
    shellRevoked: 'Ticket setunnar er ekki lengur gildur — hann rann út, eða innskráningin sem opnaði hann var afturkölluð.',
    shellHint: 'Smelltu í svarta reitinn og skrifaðu: lyklarnir fara til gámsins. Ctrl+C og örvarnar virka; exit lokar shell-inu.',
    shellStatus: {
      connecting: 'Tengist…',
      connected: 'Tengd',
      ended: 'Lokið'
    },
    deleteRunningError: '{name} er óskað í keyrslu — stöðvaðu það fyrst.',

    // Dialog standard (round #156): i tab del dettaglio e i campi contract
    // mancanti — ogni campo dell'App visibile, lucchetti col perché.
    tabs: {
      general: 'Almennt',
      image: 'Mynd',
      network: 'Net',
      storage: 'Geymsla',
      devices: 'Tæki',
      observed: 'Athugað'
    },
    attachment: 'Tenging',
    runningDigest: 'Digest í keyrslu',
    lastError: 'Síðasta villa',
    reportObservedAt: 'Síðasta skýrsla worker-sins',
    desiredStateLock: 'Þessu stjórna aðgerðirnar Ræsa/Stöðva — aldrei bein breyting.',
    ipEditDisabledHint: 'Aðeins breytanlegt með fastri úthlutun.',
    derivedFromNetworkHint: 'Leitt af einu uppsprettu netsins — handvirkt aðeins á berri brú með föstu IP.',
    ephemeralUnset: 'ekki stillt',
    ephemeralMissing: 'Hverfula geymslan fyrir öpp er ekki stillt — að búa til app með hverfulum hlutum (root eða volume) er hafnað þar til þú stillir hana.',
    ephemeralCurrent: 'Hverful geymsla appanna: {name}',
    ephemeralMissingCreate: 'Þetta app á hverfula hluti en hverfula geymslan fyrir öpp er ekki stillt — stofnuninni verður hafnað. Stilltu hana fyrst af borðanum á Öpp-síðunni.',
    setEphemeral: 'Stilla hverfula geymslu',
    changeEphemeral: 'Skipta um hverfula geymslu',
    setEphemeralTitle: 'Stilla hverfulu geymsluna fyrir öpp',
    changeEphemeralTitle: 'Skipta um hverfulu geymsluna fyrir öpp',
    ephemeralStorageHint: 'SJÁLFGEFIÐ á klasastigi: dir-pool-ið þar sem root og hverful volume hvers apps búa, nema appið lýsi yfir eigin yfirtöku. Skipti eru ekki í heitu og endurræsa ekkert: þau gilda frá næstu ræsingu hvers apps — hverful gögn flytjast ekki.',
    ephemeralPool: 'Geymslu-pool',
    ephemeralOverride: 'Hverful geymsla (yfirtaka fyrir hvert app)',
    ephemeralOverrideInherit: 'Erfa sjálfgefna gildið frá klasanum',
    ephemeralOverrideInheritNamed: 'Erfa sjálfgefna gildið frá klasanum ({name})',
    ephemeralOverrideHint: 'Pool fyrir hvert app fyrir root og hverful volume — skildu eftir autt til að erfa sjálfgefna klasagildið. Skiptin eru ekki í heitu og endurræsa ekkert: þau gilda frá næstu ræsingu (hverful gögn endurfæðast tóm á nýja pool-inu) og krefjast heimildarinnar app.ephemeralStorage.set.',
    ephemeralOverrideTag: 'yfirtaka',

    imageAnyBranch: 'Allar greinar',
    imageBranchHint: 'Þrengir myndirnar við þær sem þessi grein nefnir; án greinar sjást allar myndir geymslunnar.',
    imageDigestHint: 'Innihaldið: valið úr digest-töflunni, sem ber uppruna þess og högun. Sama greinin býður eitt fyrir hverja högun og þau eru ekki innbyrðis skiptanleg.',
    imageLockfile: 'Uppleyst tilvísun',
    imageNoImages: 'Engin mynd í skyndiminni fyrir þessa geymslu — sæktu eina úr OCI-myndum.',
    imageHeadNotCached: 'ekki í skyndiminni — sótt við ræsingu',
    imageNoRegistries: 'Engin geymsla skráð: skráðu eina til að geta valið mynd.',
    imageChosenHint: 'Myndin er valin úr keðjunni í breytingaglugganum: tilvísunin er aldrei slegin inn í höndunum.',
    registerRepositoryHint: 'Skráning sækir ekkert: hún gerir geymslu fylgjanlega svo velja megi myndina án þess að yfirgefa þennan glugga.',
    registerRepositoryBranchHint: 'Valfrjálst: fyrsta greinin sem á að fylgjast með (t.d. latest).',
    registerRepositoryElsewhere: 'Geymslan sem þú leitar að er ekki skráð: skráningin fer fram í hlutanum OCI-myndir, hjá þeim sem hefur heimildina.'
  },

  // Template CT (round K2 #63): gli oggetti CT MATERIALIZZATI — l'import da
  // catalogo è l'unico ingresso; i file si caricano dentro i cataloghi.
  cts: {
    createAction: 'Búa til CT',
    createTitle: 'Búa til gám úr sniðmáti',
    createError: 'Gámurinn var ekki búinn til',
    template: 'CT-sniðmát',
    noTemplates: 'Ekkert CT-sniðmát — flyttu eitt inn frá CT-sniðmátum',
    resources: 'Auðlindir',
    node: 'Hnútur',
    phase: {
      defined: 'Aldrei kveikt',
      materializing: 'Í raungerð',
      ready: 'Tilbúinn',
      starting: 'Í ræsingu',
      running: 'Í keyrslu',
      stopping: 'Í stöðvun',
      stopped: 'Stöðvaður',
      deleting: 'Í eyðingu',
      error: 'Í villu'
    },
    actions: {
      start: 'Ræsa',
      stop: 'Stöðva',
      restart: 'Endurræsa',
      markTemplate: 'Gera að CT-sniðmáti',
      error: 'Aðgerðinni var hafnað'
    },
    markTemplate: {
      confirmTitle: "Gera '{name}' að CT-sniðmáti?",
      confirmBody: 'Gámurinn yfirgefur þennan lista og færist í CT-sniðmátin, strax tilbúinn að geta af sér nýja CT. Lýsigögnin haldast breytanleg, og þú getur gert hann aftur að CT hvenær sem er.',
      confirm: 'Gera að sniðmáti',
      moved: "'{name}' er nú CT-sniðmát — þú finnur það í CT-sniðmátum."
    },
    stopCause: {
      api: 'Stöðvaður af TVirt',
      'ct-exit': 'Gámurinn hætti sjálfur',
      'host-reboot': 'Dó með endurræsingu hnútsins',
      'start-failed': 'Ræsingin mistókst — villa verksins segir hvað vantar og hvernig það lagast'
    },

    console: 'Stjórnskjár',
    consoleUnavailable: 'Gámurinn er ekki í keyrslu — stjórnskjár þarf lifandi gám. Annáll hans er hins vegar læsilegur í hvaða ástandi sem er.',
    consoleNoTemplate: 'Sniðmát keyrir aldrei og hefur því engan stjórnskjá: búðu til CT úr því og opnaðu hans.',
    consoleConnect: 'Tengjast',
    consoleDisconnect: 'Aftengjast',
    consoleReconnect: 'Tengjast aftur',
    consoleTakenBy: 'Annar stjórnandi tók þennan stjórnskjá ({user}). Einn stjórnskjár á gám: að tengjast aftur tekur hann til baka.',
    consoleHint: 'Smelltu á svarta reitinn og skrifaðu: lyklarnir berast til gámsins. Ctrl+C og örvarnar virka.',
    consoleEndpointDown: 'Ekki er hægt að opna aðgangspunkt stjórnborðsins á hnútnum sem þjónar container-num: {cause}',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'Container-inn er ekki í gangi — shell þarf lifandi container. Loggana hans má lesa í hvaða ástandi sem er.',
    shellNoTemplate: 'Template keyrir aldrei og hefur því enga shell: búðu til CT úr því og opnaðu hana þar.',
    shellConnect: 'Tengjast',
    shellDisconnect: 'Aftengja',
    shellExited: 'Setunni lauk með útgangskóða {code}.',
    shellEndedWithoutStatus: 'Setunni lauk án útgangsstöðu: {reason}',
    shellRevoked: 'Ticket setunnar er ekki lengur gildur — hann rann út, eða innskráningin sem opnaði hann var afturkölluð.',
    shellHint: 'Smelltu í svarta reitinn og skrifaðu: lyklarnir fara til gámsins. Ctrl+C og örvarnar virka; exit lokar shell-inu.',
    shellStatus: {
      connecting: 'Tengist…',
      connected: 'Tengd',
      ended: 'Lokið'
    },
    rootPassword: 'Root-lykilorð',
    rootPasswordHint: 'Skrifað einu sinni í afritaða rootfs (sem hash, aldrei sýnt aftur). Image dreifinganna hafa ekkert root-lykilorð: án þess er shell eina leiðin inn.',
    sshKeys: 'Opinberir SSH-lyklar root',
    sshKeysHint: 'Einn opinber OpenSSH-lykill í hverri línu, í root/.ssh/authorized_keys.',
    consoleStatus: {
      connecting: 'Tengist…',
      connected: 'Tengdur',
      reconnecting: 'Tengist aftur…'
    },
    logs: 'Annáll',
    logsTitle: 'Annáll',
    logsEmpty: 'Ekkert úttak fangað.',
    logsSource: 'Hvaða annáll',
    logsSourceConsole: 'Init-stjórnskjár gámsins — hvers vegna þjónustan inni í honum fór ekki í gang',
    logsSourceSupervisor: 'liblxc-umsjónarferlið — hvers vegna gámurinn komst aldrei svo langt að keyra',
    logsNeverStarted: 'Hann hefur aldrei verið ræstur, svo ekkert er skráð enn — ræstu hann, og annállinn verður til staðar jafnvel þótt ræsingin mistakist.',
    logsNoTemplate: 'Sniðmát keyrir aldrei og hefur því aldrei skráð neitt.',
    logsError: 'Ekki tókst að fanga annálinn',

    // Dialog standard (round #156): i tab del dettaglio condivisi dalle
    // liste CT e Template CT, più i lucchetti col perché.
    tabs: {
      general: 'Almennt',
      hardware: 'Vélbúnaður',
      network: 'Net',
      provenance: 'Uppruni'
    },
    templateFlag: 'CT-sniðmát',
    templateLock: 'Þessu er aðeins breytt með aðgerðunum Gera að sniðmáti / Gera aftur að CT — aldrei bein breyting.',
    sourceLock: 'Uppruni, skráður við fæðingu — aldrei endurskrifaður; dauð uppspretta skilur tilvísunina eftir bera.',
    storageLock: 'Fest við stofnun — flutningur rootfs er round framtíðarinnar.',
    startedAt: 'Ræstur',
    lastStop: 'Síðasta stöðvun',
    editNicsTitle: 'Breyta netum',
    nicDisconnected: 'aftengd'
  },
  ctTemplates: {
    title: 'CT-sniðmát',
    importAction: 'Flytja inn úr katalógi',
    importTitle: 'Flytja inn CT-sniðmát úr katalóginum',
    importSubmit: 'Flytja inn',
    importError: 'Innflutningnum var hafnað',
    importHint: 'Raungerð afritar rootfs á völdu geymsluna — katalógskráin helst ósnert. Til að bæta við nýjum skrám, hlaðið þeim fyrst upp í katalóg.',
    sourceFile: 'CT-sniðmátsskrá',
    sourceFileHint: 'ct-rootfs-skrár valda katalógsins, aðeins þær tilbúnu',
    noFiles: 'Engin tilbúin ct-rootfs-skrá í þessum katalógi — hlaðið einni upp af síðu katalógsins',
    source: 'Upprunaskrá',
    rootfsStorage: 'Geymsla rootfs',
    rootfsStorageHint: "Þar sem útdregna rootfs-tréð býr — geymsla með skráakerfi og nægu lausu plássi fyrir útdregnu stærðina auk um það bil 1 GiB svigrúms (annars mistekst innflutningurinn).",
    resources: 'Auðlindir',
    cores: 'vCPU',
    memoryMiB: 'Minni (MiB)',
    cpuLimit: 'CPU-hámark',
    cpuLimitHint: 'Jafngildi hýsilkjarna (t.d. 1.5); autt = án þaks',
    cpuUncapped: 'án þaks',
    cpuWeight: 'CPU-vægi',
    hostname: 'Hýsilnafn',
    hostnameHint: 'Autt = nafn CT-sins',
    nameservers: 'DNS-nafnaþjónar',
    dnsHint: 'Aðskildir með kommu; autt = erfir þá frá hýslinum',
    searchDomains: 'DNS-leitarlén',
    dnsInherited: 'Erft frá hýslinum',
    networks: 'Net',
    nicSlot: 'NIC-rauf',
    phase: {
      materializing: 'Í raungerð',
      ready: 'Tilbúið',
      deleting: 'Í eyðingu',
      error: 'Villa'
    },
    exportAction: 'Flytja út í katalóg',
    exportTitle: 'Flytja út í katalóg',
    exportSubmit: 'Flytja út',
    exportError: 'Útflutningnum var hafnað',
    exportHint: 'Pakkar raungerða rootfs-inu í NÝJA ct-rootfs-skrá í völdum katalógi — sniðmátið helst ósnert.',
    exportName: 'Nafn skrárinnar',
    exportNameHint: 'Autt = <sniðmát>-export-<n>',
    markCt: {
      action: 'Gera aftur að CT',
      confirmTitle: "Gera '{name}' aftur að CT?",
      confirmBody: 'Sniðmátið yfirgefur þennan lista og fer aftur í CT-listann, ræsanlegt á ný. Þar til þú gerir það aftur að sniðmáti er ekki hægt að búa til CT úr því.',
      confirm: 'Gera aftur að CT',
      moved: "'{name}' er aftur CT — þú finnur það í CT-listanum."
    }
  },

  // OCI wave 1 (Annex Q — il modello tag-come-branch): un tag OCI è un branch
  // (puntatore mobile), il digest è il commit; refresh = "git fetch",
  // pull = risolvi ADESSO, scarica QUEL digest.
  oci: {
    registriesTitle: 'OCI-registries',
    imagesTitle: 'OCI-myndir',
    provider: 'Veitandi',
    providerDockerhub: 'Docker Hub',
    providerGhcr: 'GHCR',
    providerEcr: 'Amazon ECR',
    providerQuay: 'Red Hat Quay',
    providerGeneric: 'Almennt',
    providerImmutableHint: 'Veitandinn er óbreytanlegur eftir stofnun — annar veitandi er nýtt registry.',
    url: 'URL',
    urlHintPreset: 'Fyrirframútfyllt af veitandanum — skrifaðu aðeins yfir fyrir mirror.',
    urlHintRequired: 'Skylda fyrir almenn registry: https:// grunn-URL-ið.',
    urlHintEcr: 'Skylda: ECR-endapunktar eru fyrir hvern reikning/hvert svæði — ekkert preset er til.',
    credential: 'Aðgangsupplýsingar',
    credentialNone: 'Nafnlaus aðgangur',
    credentialHint: 'Keystore-færsla með notanda og lykilorði; worker-arnir leysa hana upp við notkun — aldrei auth-skrá á hnút.',
    nameHint: 'Nafn í hýsilsstíl (docker.io, registry.intra); einkvæmt innan scope, óbreytanlegt',
    addRegistry: 'Bæta við registry',
    addRegistryTitle: 'Bæta við OCI-registry',
    verify: 'Sannreyna',
    verifyState: 'Sannprófun',
    verified: 'Sannreynt',
    verifyFailed: 'Mistókst',
    neverVerified: 'Aldrei sannreynt',
    registryInUseError: "'{name}' á enn skráð repository — eyddu þeim fyrst.",
    repositories: 'Repository',
    repositoriesHint: 'Skráning fylgist með branch-um (OCI-tags) — sækir ekkert. Refresh leysir upp hvert fylgt branch og heldur reflog-inu.',
    noRepositories: 'Ekkert repository skráð á þessu registry.',
    registerRepository: 'Skrá repository',
    repoPath: 'Slóð',
    repoPathHint: "Slóð repository-sins á registry-inu, t.d. 'example' eða 'library/nginx'",
    branches: 'Branch',
    branchesHint: 'Fylgd branch (OCI-tags), aðskilin með kommu — t.d. 1.1.0, 1.1.1',
    branch: 'Branch',
    branchPullHint: 'Leyst upp NÚNA: pull sækir digest-ið sem branch-ið bendir á í dag.',
    refresh: 'Uppfæra',
    deleteRepository: 'Eyða repository',
    reflogCount: '{n} fyrri',
    noResolutions: 'Aldrei uppfært — engin upplausn athuguð.',
    refreshFailed: 'Síðasta uppfærsla mistókst ({when})',
    loadError: 'Ekki tókst að sækja repository-in.',
    reference: 'Tilvísun',
    digest: 'Digest',
    digestHint: 'sha256:… — nákvæma myndin, án branch (detached)',
    size: 'Stærð',
    nodes: 'Hnútar',
    detached: 'detached',
    detachedHint: 'Sótt eftir digest, án branch — drift-eftirlitið á ekki við.',
    pulledAt: 'Sótt',
    pull: 'Pull',
    pullTitle: 'Pull á mynd',
    pullHint: 'Forhitun, aldrei forsenda: pull eftir branch leysir upp NÚNA og sækir ÞAÐ digest; pull eftir digest er detached.',
    pullError: 'Pull-inu var hafnað',
    pullMode: 'Pull eftir',
    pullModeBranch: 'Branch (leysa upp núna)',
    pullModeDigest: 'Digest (detached)',
    pullModeBranchHint: 'Heiðarlega sjálfgefna leiðin: eins og apt install — endurtekið síðar getur það gefið aðra mynd.',
    pullModeDigestHint: 'Nákvæmt digest — endurgeranleiki og rollback; afsalar sér drift-eftirlitinu.',

    // Il pattern a due pulsanti (#88, ratifica 2026-07-30 sera): "da
    // registry" è il pull guidato esistente, "da catalogo" materializza un
    // archivio oci-image pronto (la via air-gapped).
    importFromRegistry: 'Flytja inn frá registry',
    importFromCatalog: 'Flytja inn úr katalógi',
    importCatalogTitle: 'Flytja inn OCI-mynd úr katalógi',
    importCatalogHint: 'Air-gapped leiðin: tilbúið oci-image-safn (tar/tar.gz — docker-archive eða oci-archive) er raungert í myndageymslunni með tilvísuninni catalog/<katalógur>/<skrá>@<digest>; öppin neyta hennar eins og hverrar annarrar myndar. Söfnin eru hlaðin upp í katalógana — þessi hluti flytur bara inn.',
    importCatalogFile: 'Safnskrá',
    importCatalogFileHint: 'Tilbúnu oci-image-skrár valda katalógsins.',
    importCatalogNoFiles: 'Ekkert tilbúið oci-image-safn í þessum katalógi — hlaðið einu upp úr katalógsyfirlitinu.',
    importCatalogError: 'Innflutningnum var hafnað',
    registry: 'Registry',
    repository: 'Repository',
    cacheMissing: 'OCI-skyndiminni klasans er ekki stillt — pull er hafnað þar til þú stillir geymslu-pool.',
    setCache: 'Stilla skyndiminni',
    setCacheTitle: 'Stilla OCI-skyndiminnið',
    setCacheHint: 'SJÁLFGEFNA pool-ið á klasastigi sem hýsir blob sóttra mynda — scope getur tekið yfir með eigin pool-i (Scope-síðan). Skipti eru ekki í heitu og endurræsa ekkert, og flytja ekki blob-in: þau birtast aftur lazy við næstu ræsingu/notkun.',
    cachePool: 'Geymslu-pool',
    changeCache: 'Skipta um skyndiminni',
    changeCacheTitle: 'Skipta um pool OCI-skyndiminnisins',
    cacheCurrent: 'OCI-skyndiminni klasans (sjálfgefið): {name}',
    sectionOverview: 'Yfirlit',
    sectionRepositories: 'Repository',
    sectionExplore: 'Skoða',
    exploreHint: 'Fjarleit í rauntíma á registry-inu — Docker Hub að fullu (lýsing, niðurhal, stjörnur), aðrir veitendur best-effort. Veldu niðurstöðu til að lesa alla lýsinguna og fletta fjarlægum tags hennar; frá tagi geturðu bætt tilvísuninni við TVirt-repository.',
    exploreSearch: 'Leita',
    exploreUnsupported: 'Þessi veitandi styður ekki leit.',
    exploreNoResult: 'Ekkert samsvarandi repository.',
    exploreNoTags: 'Ekkert samsvarandi tag á þessu repository.',
    exploreOfficial: 'Opinbert',
    explorePulls: 'Niðurhal',
    exploreStars: 'Stjörnur',
    exploreUpdated: 'Uppfært {when}',
    exploreLoadMore: 'Sækja fleiri',
    exploreSelectHint: 'Veldu niðurstöðu: öll lýsingin og fjarlægu tags hlaðast hér.',
    exploreNoDescription: 'Engin lýsing tiltæk frá þessum veitanda.',
    exploreTagsTitle: 'Fjarlæg tags',
    exploreTagFilter: 'Leita að tagi',
    exploreAddToRepo: 'Bæta við repository',
    exploreAdded: '{path}:{tag} er nú fylgt — sjá Repository-hlutann.',
    addBranch: 'Bæta við branch',
    purgeRequiredTitle: "Eyða '{name}' og myndum þess?",
    purgeRequiredBody: 'Ekkert app neytir þessa repository-s, en enn eru til sóttar myndir: eyðing fjarlægir líka færslur þeirra, og blob-in í skyndiminninu fara til garbage collector-sins.',
    purgeConfirm: 'Eyða líka myndunum',
    providerSelectHint: 'Veldu tegund registry-sins: kortið segir frá preset-um og notkun.',
    providerDesc: {
      dockerhub: 'Opinbera Docker-registry-ið: fyrirframútfyllt URL, full leit með lýsingum og talningum.',
      ghcr: 'GitHub Container Registry: fyrirframútfyllt URL; reikningarnir nota personal access token.',
      ecr: 'Amazon Elastic Container Registry: endapunktar fyrir hvern reikning/hvert svæði — URL-ið þarf að gefa upp.',
      quay: 'Red Hat Quay-registry-ið: fyrirframútfyllt URL.',
      generic: 'Self-hosted registry (Harbor, registry:2, …): https:// URL-ið er skylda.'
    },

    // Dialog standard (round #156): i campi del dettaglio immagine/registry
    // che le colonne non mostravano.
    layerCount: 'Layer',
    verifiedAt: 'Síðasta sannprófun',
    verifyOk: 'Niðurstaða',
    verifyMessage: 'Skilaboð sannprófunar',

    // Líkanið #348/R39: myndin ER digest-ið — innihaldið — og registry, geymsla og grein eru NÖFNIN sem ná til þess.
    head: 'Head',
    heads: 'Hausar eftir högun',
    listDigest: 'Digest listans',
    neverResolved: 'Aldrei leyst upp',
    totalSize: 'Heildarstærð',
    reflogTitle: 'Saga upplausnanna',
    usedBy: 'Notað af',
    usageLockfile: 'lockfile',
    usageRunning: 'í keyrslu',
    evictable: 'úthýsanlegt',
    evict: 'Úthýsa úr skyndiminninu',
    evictHeadTitle: 'Úthýsa {digest}?',
    evictHeadBody: 'Það er núverandi upplausn að minnsta kosti eins safnara: að úthýsa því er lögmætt — þetta er bara skyndiminni, fjarlæga branch-ið ber það enn fram — en það má ekki gerast fyrir slysni. Blob-ið er EITT: úthýsingin tæmir alla safnarana sem deila því.',
    evictConfirm: 'Úthýsa því samt',

    arch: 'Högun',
    names: 'Nöfn',
    noNames: 'ekkert nafn',
    views: 'Sýnir',
    lastView: 'síðasta sýn',
    evictLastViewTitle: 'Fjarlægja síðustu tilvísun í {digest}?',
    evictLastViewBody: 'Þetta er síðasta sýnin á þetta innihald: sé hún fjarlægð hættir myndin að vera til á TVirt og bætin ({size}) losna. Þetta er docker image rm líkansins — engin hliðarverkun heldur aðgerðin sjálf.',
    branchesTabHint: 'Fylgdar greinar þessarar geymslu: fyrir hverja hausar dagsins — einn fyrir hverja högun — tímaröð uppfærslnanna og hve margar mynda sem hún nefndi eru í skyndiminni. Uppfærslan er «git fetch» geymslunnar: hún leysir allar greinar hennar í einu.',
    noBranches: 'Engri grein er fylgt í þessari geymslu.',
    stopObserving: 'Hætta að fylgjast með greininni',
    pullBranch: 'Sækja haus branchsins í skyndiminnið (refresh leysir, þetta sækir)',
    pullDigest: 'Sækja þetta digest í skyndiminnið',
    imageCount: 'Myndir',
    deleteBranchPurgeTitle: 'Skilja myndir {name} eftir nafnlausar?',
    deleteBranchPurgeBody: 'Ekkert forrit nefnir þessa grein, en sumar myndir nást aðeins um hana: sé henni eytt verða þær eftir í skyndiminni nafnlausar, taldar meðal mynda geymslunnar og hægt að hreinsa í höndunum.',
    deleteBranchPurgeConfirm: 'Eyða og skilja myndir eftir nafnlausar',
    imagesTabHint: 'Myndir þessarar geymslu — innihaldið, það er digest-in — sjást líka án þess að velja grein. Mynd er einstök á hverjum klasa: nöfnin sem ná til hennar geta verið fleiri en eitt.',
    noImages: 'Engin mynd þessarar geymslu er raungerð í skyndiminni.',
    deleteRepositoryTitle: 'Eyða {name}?',
    deleteRepositoryBody: 'Geymslan og greinar hennar hverfa með tímaröð sinni. Myndirnar verða áfram í skyndiminni: þær missa aðeins þetta nafn. Geymslu sem forrit nefnir er ekki hægt að eyða.',
    provenanceCatalog: 'safnskrá',
    refreshedAt: 'Uppfært',
    neverRefreshed: 'Aldrei uppfært',
    sectionBranches: 'Greinar',
    sectionImages: 'Myndir',
    repositoriesGovernedElsewhere: 'Hér er aðeins horft á geymslur: að skrá þær, uppfæra þær, fylgjast með greinum þeirra og hreinsa myndir þeirra gerist í hlutanum OCI-myndir.',
    gotoImages: 'Fara í OCI-myndir'
  },

  // Pod nativi (P1): the Pod list — the template's census of instances, the
  // whole-Pod lifecycle, the scale and the delete.
  pods: {
    title: 'Pods',
    containers: 'Gámar',
    instances: 'Tilvik',
    instancesTooltip: '{running} keyrandi, {error} í villu',
    placement: 'Staðsetning',
    spread: 'dreifing',
    ha: 'HA',
    templateRevision: 'útgáfa',
    deleting: 'Verið að eyða',
    empty: 'Engin pod — búðu til app (einn gám) eða pod úr CLI (create-pod).',
    openInstances: 'Opna tilvikin',
    rollingRestart: 'Rúllandi endurræsing',
    scale: 'Skala',
    scaleTitle: 'Skala {name}',
    scaleHint: 'Fjöldi tilvika (0–64): upp fyllir lægsta lausa raðnúmer, niður dregur það hæsta til baka og varanleg gögn þess haldast.',
    scaleError: 'Skölun mistókst',
    replicas: 'Afrit',
    deleteRunningError: '{name} er í keyrslu — stöðvaðu það fyrst.',
    deleteInstancesIntro: 'Öll {count} tilvikin verða fjarlægð.',
    stateRunning: 'Keyrandi',
    stateStopped: 'Stöðvað',
    editor: {
      createTitle: 'Búa til Pod',
      create: 'Búa til Pod',
      editTitle: 'Breyta Pod',
      nameHint: 'DNS-1123, að hámarki 58 stafir — tilvikin heita <nafn>-<vísir>; óbreytanlegt eftir stofnun.',
      restartPolicy: 'Endurræsingarstefna',
      restartPolicyHint_always: 'Hnúturinn endurræsir hvern gám sem hættir, með veldisvaxandi bið (10 s → 5 mín).',
      restartPolicyHint_onFailure: 'Aðeins gámur sem hættir með kóða öðrum en núll er endurræstur; útgangur 0 hvílir.',
      restartPolicyHint_never: 'Gámur sem hættir er látinn eiga sig — tilvikið endar sem succeeded eða failed.',
      grace: 'Frestur (s)',
      graceHint: 'SIGTERM → SIGKILL mörk stöðvunar.',
      hostname: 'Hýsilsheiti',
      hostnameHint: 'Tómt = nafn tilviksins.',
      hostnameDefault: 'nafn tilviksins',
      sharePid: 'Deila PID-nafnrými milli gámanna',
      containersIntro: 'Init-gámar keyra til enda, í röð, áður en gámarnir ræsa; gámarnir deila neti tilviksins (ein IP, localhost sín á milli).',
      initContainers: 'Init-gámar',
      initAdd: 'Bæta við init-gámi',
      initHint: 'Hver verður að hætta með 0; mistök setja tilvikið í villu og hnúturinn reynir aftur með bið.',
      containerAdd: 'Bæta við gámi',
      atLeastOne: 'Pod þarf að minnsta kosti einn gám.',
      duplicateNames: 'Gámaheiti verða að vera einkvæm innan Pod (init-gámar meðtaldir).',
      containerName: 'Heiti gáms',
      containerInvalid: 'Þessi gámur er ófullkominn: heiti (DNS-1123), mynd, tengingar við skilgreind bindi, töluleg mörk og prófun.',
      command: 'Skipun',
      commandHint: 'Yfirskrifar entrypoint myndarinnar — ein færibreyta á línu, aldrei skeljarstrengur.',
      args: 'Færibreytur',
      argsHint: 'Ein á línu (CMD myndarinnar ef tómt).',
      mounts: 'Tengingar',
      mountAdd: 'Bæta við tengingu',
      mountNoVolumes: 'Skilgreindu fyrst bindi í flipanum Geymsla.',
      readOnly: 'aðeins lestur',
      resources: 'Mörk',
      cpus: 'CPU',
      cpusHint: 'podman --cpus (t.d. 1.5)',
      memory: 'Minni (MiB)',
      memoryHint: 'podman --memory',
      health: 'Lífsmarkaprófun',
      healthCmd: 'Prófunarskipun',
      healthCmdHint: 'Keyrð inni í gámnum af hnútnum við hvert eftirlitstikk — ein færibreyta á línu; útgangur 0 = heilbrigt.',
      healthTimeout: 'Tímamörk (s)',
      healthRetries: 'Tilraunir',
      healthRetriesHint: 'Samfelld mistök áður en hnúturinn endurræsir gáminn.',
      ips: 'Föst vistföng',
      ipsHint: 'Eitt á tilvik, í raðtöluröð — skölun út fyrir listann er hafnað.',
      instance: 'tilvik',
      volumesHint: 'Bindin tilheyra Pod; tengislóðin tilheyrir hverjum gámi (flipinn Gámar).',
      spread: 'Dreifing',
      spreadHint_preferred: 'Tilvik á ólíkum hnútum þegar hægt er.',
      spreadHint_required: 'Tilvik á ólíkum hnútum, annars hafnar skölunin.',
      spreadHint_none: 'Aðeins ákvarðandinn.',
      ha: 'Hátt aðgengi (opt-in)',
      haHint: 'Hver varanlegur hluti á deildri geymslu; ef hnúturinn deyr endurskapar HA-deciderinn tilvikin á öðrum meðlim (sjálfvirkt failover, eins og HA-VM).',
      yes: 'já',
      no: 'nei'
    },
    detail: {
      container: 'Gámur',
      actions: 'Aðgerðir',
      ready: 'Tilbúið',
      notReady: 'Ekki tilbúið',
      restarts: 'Endurræsingar',
      lastRestartAt: 'Síðasta endurræsing:',
      backoffUntil: 'Reynt aftur kl.',
      stateAbsent: 'vantar',
      stateRunning: 'í gangi',
      stateTerminated: 'lokið',
      stateWaiting: 'bíður',
      init: 'init',
      noInstances: 'Engin tilvik (eintök 0).',
      ha: 'HA',
      haHint: 'Sjálfvirkt failover: ef hnúturinn deyr endurskapar HA-deciderinn tilvikið á öðrum meðlim (hver varanlegur hluti á deildri geymslu).',
      authority: 'Authority (hnútur)',
      homeless: 'án authority',
      homelessHint: 'Endurheimt úr checkpoint skilur authority eftir (#380): enginn hnútur þjónar því fyrr en þú skalar Podið (jafnvel í sama fjölda eftirmynda).',
      restartContainer: 'Endurræsa aðeins þennan gám (pod heldur áfram)',
      divergingHint: 'Óskuð staða þessa tilviks víkur frá sjálfgildi Pod (PD-P19).',
      revisionLag: 'útgáfa {applied} beitt af {current}',
      updatedInstances: '{updated}/{desired} tilvik á þessari útgáfu'
    }
  }
}
